import axios from '../../axios'

/*
 * 考生数据接口
 */

// 获取考生列表
export const getStudentList = (data) => {
    return axios({
        url: '/api/mock/app/student',
        method: 'get',
        data
    })
}
export const uploadStuList = (data) => {
    return axios({
        url: '/api/mock/app/import_student',
        method: 'post',
        data
    })
}

// 文件批量删除
export const fileBatchDelStudent = (data) => {
    return axios({
        url: '/api/mock/app/delete/file/batch/student',
        method: 'POST',
        data
    })
}

// 批量删除
export const deleteStudent = (data) => {
    return axios({
        url: '/api/mock/app/delete_batch_student',
        method: 'delete',
        data
    })
}
export const updateStudent = (data) => {
    return axios({
        url: '/api/mock/app/save_student',
        method: 'put',
        data
    })
}

export const getExamListByProvince = (data) => {
    return axios({
        url: '/api/mock/base/exam_list',
        method: 'get',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/app/student.js